export function urlData(){
  let showUrlLocal=false
  //return !showUrlLocal?process.env.REACT_APP_API_URL:process.env.REACT_APP_API_URL_LOCAL;
  return !showUrlLocal?process.env.REACT_APP_API_URL:process.env.REACT_APP_API_URL_LOCAL;
}

export function urlDataImage(){
  return process.env.REACT_APP_API_URL_IMAGE;
}